/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Sentence_EndInputs */

const en_seo_sentence_end = /** @type {(inputs: Seo_Sentence_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const zh_hans1_seo_sentence_end = /** @type {(inputs: Seo_Sentence_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`。`)
};

const pt_br2_seo_sentence_end = /** @type {(inputs: Seo_Sentence_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const es_seo_sentence_end = /** @type {(inputs: Seo_Sentence_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const fr_seo_sentence_end = /** @type {(inputs: Seo_Sentence_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const de_seo_sentence_end = /** @type {(inputs: Seo_Sentence_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const ru_seo_sentence_end = /** @type {(inputs: Seo_Sentence_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const it_seo_sentence_end = /** @type {(inputs: Seo_Sentence_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "." |
*
* @param {Seo_Sentence_EndInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_sentence_end = /** @type {((inputs?: Seo_Sentence_EndInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Sentence_EndInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_sentence_end(inputs)
	if (locale === "pt-BR") return pt_br2_seo_sentence_end(inputs)
	if (locale === "es") return es_seo_sentence_end(inputs)
	if (locale === "fr") return fr_seo_sentence_end(inputs)
	if (locale === "de") return de_seo_sentence_end(inputs)
	if (locale === "ru") return ru_seo_sentence_end(inputs)
	if (locale === "it") return it_seo_sentence_end(inputs)
	return en_seo_sentence_end(inputs)
});